import React from 'react';

function Footer() {
  return (
    <div className="footer">
      © 2025 Employee Management App. All rights reserved.
    </div>
  );
}

export default Footer;
